import React, { useState, useEffect } from "react";
import ContactCard from "./SocialCard";
import Loading from "./Loading";
import { LinkedIn, MailOutline } from "@material-ui/icons";
import "../scss/members.scss";

import { getMembers } from "../utils/API";

const MemberCard = ({ avatar, name, role, description, linkedin, email }) => {
  return (
    <div className="member-card">
      <img src={`${process.env.REACT_APP_API_URI}/${avatar}`} alt="avatar personnel" className="avatar" />
      <div className="body-card">
        <h3 className="member-name">{name}</h3>
        <p className="member-role">{role}</p>
        <p className="member-description-p">{description}</p>
        <div className="member-contact">
          <ContactCard Icon={LinkedIn} url={linkedin} customStyle="linkedin" />
          <ContactCard
            Icon={MailOutline}
            url={`mailto:${email}`}
            customStyle="email"
          />
        </div>
      </div>
    </div>
  );
};

const MemberList = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getMembers();
        setMembers(res.data);
        setLoading(false);
      } catch (error) {
        console.error(
          "Un problème est survenu lors de la lecture des données !"
        );
      }

    };
    fetchData();
  }, []);


  return (
    <div className="members-container">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <h2>L'équipe de Cartésia Junior</h2>
          <div className="member-list">
            {members.map((member, index) => (
              <MemberCard
                key={index}
                avatar={member.avatar}
                name={member.name}
                role={member.role}
                description={member.description}
                linkedin={member.linkedin}
                email={member.email}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberList;
